import React from 'react';
import { Link } from 'react-router-dom';
import { ClipboardList } from 'lucide-react';
import { useUser } from '../../context/UserContext';

export default function OperationsEntryLink({ className = '', labelClassName = '' }) {
  const { canAccessOperations } = useUser();
  if (!canAccessOperations) return null;
  return <Link to="/operations" className={className} aria-label="运营管理" title="运营管理">
    <ClipboardList size={15} aria-hidden="true" />
    <span className={labelClassName}>运营管理</span>
  </Link>;
}
